import http from "@/settings/apiSettings";

class ERP_ParametriAplicatieService {
    save(data: any): Promise<any> {
        return http.clientAuthOdata.post("/ERP_ParametriAplicatie", data);
    }

    update(cod: string, data: any): Promise<any> {
        return http.clientAuthOdata.put(`/ERP_ParametriAplicatie('${cod}')`, data);
    }

    delete(cod: string): Promise<any> {
        return http.clientAuthOdata.delete(`/ERP_ParametriAplicatie('${cod}')`);
    }
}

export default new ERP_ParametriAplicatieService();
